/**
 * Socle CSS de la v2 (ux-v2.css), posé AVANT les feuilles des écrans.
 *
 * Module à effet de bord importé par mount.tsx avant AppV2 : l'évaluation des modules suit l'ordre des imports, et
 * chaque écran pose sa feuille à l'évaluation de son module (styles/inject.ts). Posé dans le corps de mount.tsx, le
 * socle arrivait APRÈS les feuilles des écrans et, à spécificité égale, l'emportait sur elles : le liseré vert du
 * panneau « C’est réservé » (class.css) et le rembourrage du plan sans salle restaient ceux de .mmv2-card (revue du
 * 04/10, défaut latent depuis 2a9cef8). Ordre voulu : socle, puis écrans, qui l'affinent.
 */
import { injectV2Css } from './inject';
import uxV2Css from './ux-v2.css?inline';

injectV2Css('styles/ux-v2.css', uxV2Css);
